export default __webpack_public_path__ + "static/media/h4.8171ef9f.jpg";